import httpClient from './_httpClient';
import httpClientWithoutToken from "./_httpClientWithoutToken";

const END_POINT = '/scopes';

const getAllScopes = () => httpClient.get(END_POINT + '?paginated=false');
const getOneScope = (id) => httpClient.get( 'oneScope/' + id);
const addScope = (scopeData) => httpClient.post(END_POINT, scopeData);
const editScope = (id, scopeData) => httpClient.put(END_POINT + '/' + id, scopeData);
const deleteScope = (id) => httpClient.delete(END_POINT + '/' + id);
const usersInScopes = (id) => httpClient.get('/usersInScopes/' + id);
const getScopeLanguages = (scopeId) => httpClient.get(END_POINT + '/' + scopeId + '/languages');
const getDefaultScopeIdForList = () => httpClient.get(END_POINT + '/defaultScopeIdForList');

// Nav credentials APIs
const getScopeNavCredentials = (scopeId) => httpClient.get(END_POINT + '/' + scopeId + '/nav-credentials');
const updateScopeNavCredentials = (scopeId, navCredentials) => httpClient.put(END_POINT + '/' + scopeId + '/nav-credentials', navCredentials);
const checkNavStatus = (scopeId) => httpClient.post(END_POINT + '/' + scopeId + '/nav-status');
const getNavStatusHistory = (scopeId) => httpClient.get(END_POINT + '/' + scopeId + '/nav-status');
const testNavCredentials = (scopeId,navCredentials) => httpClient.post(END_POINT + '/' + scopeId + "/test-nav-credentials",navCredentials);
const smsLogs = (scopeId, config) => httpClient.get( '/excel/' + scopeId, config);
const monitoringJobs = (scopeId) => httpClient.get(END_POINT + '/' + scopeId + '/monitoring');
const launchJobs = (jobIds) => httpClient.post(END_POINT + '/launch', {jobIds});

// Allowed mobile countries
const getAllowedMobileCountriesPerScope = (scopeId) => httpClient.get(END_POINT + '/' + scopeId + '/mobile-countries');
const getAllowedMobileCountries = () => httpClientWithoutToken.get(END_POINT + '/mobile-countries');
const addAllowedMobileCountries = (scopeId, countries) => httpClient.post(END_POINT + '/' + scopeId + '/mobile-countries',{countries: countries});

const getCronConfig = (scopeId) => httpClient.get(END_POINT + '/' + scopeId + '/cron_config/');
const getTimezonesList = () => httpClient.get('timezones_list');
const updateCronConfig = (cronConfigId, data) => httpClient.put(END_POINT + '/cron_config/' + cronConfigId, data);
const getOneCronConfig = (cronConfigId) => httpClient.get(END_POINT + '/cron_config/' + cronConfigId);

const enableOrDisableScope = (scopeId) => httpClient.post(END_POINT + '/enableOrDisableScope/' + scopeId);

export {
  getAllScopes,
  addScope,
  editScope,
  deleteScope,
  getOneScope,
  usersInScopes,
  getScopeNavCredentials,
  updateScopeNavCredentials,
  checkNavStatus,
  testNavCredentials,
  getScopeLanguages,
  getNavStatusHistory,
  smsLogs,
  monitoringJobs,
  launchJobs,
  getAllowedMobileCountriesPerScope,
  getAllowedMobileCountries,
  addAllowedMobileCountries,
  getCronConfig,
  getTimezonesList,
  updateCronConfig,
  getOneCronConfig,
  getDefaultScopeIdForList,
  enableOrDisableScope
}
